import { DEV_BASE_URL } from "../constants";
import api from './api';

export async function getUserCart(limit, courseId) {
    try {
        let url = DEV_BASE_URL + "get_cart/";
        const res = await api.get(url);
        return res['data']
    } catch (error) {
        // console.error('There was an error fetching the data:', error);
        throw error;
    }
}

export async function getCoupons(page) {
    try {
        let url = DEV_BASE_URL + "get_coupons/?page="+page;
        const res = await api.get(url);
        return res['data']
    } catch (error) {
        // console.error('There was an error fetching the data:', error);
        throw error;
    }
}

export async function getCourseSyllabus(courseId) {
    try {
        let url = DEV_BASE_URL + "get_syllabus/?course_id="+courseId;
        const res = await api.get(url);
        return res['data']
    } catch (error) {
        // console.error('There was an error fetching the data:', error);
        throw error;
    }
}

export async function getCourseInstructor(courseId) {
    try {
        let url = DEV_BASE_URL + "get_course_instructor/?course_id="+courseId;
        const res = await api.get(url);
        return res['data']
    } catch (error) {
        // console.error('There was an error fetching the data:', error);
        throw error;
    }
}

export async function clearCart() {
    try {
        let url = DEV_BASE_URL + "clear_cart/";
        const res = await api.get(url);
        return res['data']
    } catch (error) {
        // console.error('There was an error fetching the data:', error);
        throw error;
    }
}

export async function createBookDemoLead(data) {
    try {
        let url = DEV_BASE_URL + "create_new_lead/";
        let fina_data = {
            'source': 'web',
            'source_id': 1,
            'stage': data['stage'],
            data
        }
        const res = await api.post(url, fina_data);
        return res['data']
    } catch (error) {
        // console.error('There was an error Creating lead:', error);
        throw error;
    }
}

export async function checkout(data) {
    try {
        let url = DEV_BASE_URL + "checkout/";
        let fina_data = {
            'source': 'web',
            'source_id': 1,
            'stage': 'checkout',
            data
        }
        const res = await api.post(url, fina_data);
        return res['data']
    } catch (error) {
        // console.error('There was an error Creating lead:', error);
        throw error;
    }
}

export const getVapidKey = async () => {
    try {
        let url = DEV_BASE_URL + "vapid_key/";
        const res = await api.get(url);
        return res['data'];
    } catch (error) {
        // console.error('There was an error fetching the data:', error);
        throw error;
    }
  };
  
  export const saveSubscription = async (subscription) => {

    try {
        let url = DEV_BASE_URL + "save_subscription/"
        let headers = { "Content-Type": "application/json" }
        const res = await api.post(url,  JSON.stringify(subscription), headers)
        return res['data'];
    } catch(error) {
        // console.log('There was an error in Subscription: ', error)
        throw error;
    }
  };

export async function registerStudent(data) {
    try {
        let url = DEV_BASE_URL + "exam/register/";
        let fina_data = data
        fina_data['source'] = 'web'
        const res = await api.post(url, fina_data);
        return res['data']
    } catch (error) {
        // console.error('There was an error Creating lead:', error);
        throw error;
    }
}

export async function loginStudent(data) {
    try {
        let url = DEV_BASE_URL + "exam/login/";
        let fina_data = data
        fina_data['source'] = 'web'
        const res = await api.post(url, fina_data);
        return res['data']
    } catch (error) {
        // console.error('There was an error Creating lead:', error);
        throw error;
    }
}

export async function fetchStudentTest() {
    try {
        let url = DEV_BASE_URL + "exam/user/list/?source=web";
        const res = await api.get(url);
        return res['data'];
    } catch (error) {
        throw error;
    }
}

export async function fetchTest(test_id) {
    try {
        let url = DEV_BASE_URL + "exam/tests/data/?source=web&test_id="+test_id;
        const res = await api.get(url);
        return res['data'];
    } catch (error) {
        throw error;
    }
}

export async function fetchTestData(test_id) {
    try {
        let url = DEV_BASE_URL + "exam/test/data/?source=web&test_id="+test_id;
        const res = await api.get(url);
        return res['data'];
    } catch (error) {
        throw error;
    }
}

export async function sendTestFlags(data) {
    try {
        let url = DEV_BASE_URL + "exam/test/flags/";
        let fina_data = data
        fina_data['source'] = 'web'
        const res = await api.post(url, fina_data);
        return res['data']
    } catch (error) {
        // console.error('There was an error Creating lead:', error);
        throw error;
    }
}

export async function submitTest(data) {
    try {
        let url = DEV_BASE_URL + "exam/test/submit/";
        let fina_data = data
        fina_data['source'] = 'web'
        const res = await api.post(url, fina_data);
        return res['data']
    } catch (error) {
        // console.error('There was an error Creating lead:', error);
        throw error;
    }
}
